/**
 * One-time migration from single-vehicle localStorage format to multi-garage/multi-vehicle.
 * Called once at app startup before any data loading.
 */
export function migrateIfNeeded() {
  // If new format already exists, nothing to do
  if (localStorage.getItem('pm_garages')) return;

  // Check for old single-vehicle data
  const oldVehicle = localStorage.getItem('pm_vehicle');
  if (!oldVehicle) return; // Fresh install, no data to migrate

  const garageId = `garage_${Date.now()}`;
  const vehicleId = `vehicle_${Date.now()}`;

  // Parse old data
  const vehicleData = JSON.parse(oldVehicle);
  const analysisData = localStorage.getItem('pm_analysis');
  const chatHistory = localStorage.getItem('pm_chat_history');
  const serviceHistory = localStorage.getItem('pm_service_history');

  // Build new garage
  const garage = {
    id: garageId,
    name: 'My Garage',
    photo: null,
    vehicleIds: [vehicleId],
  };

  // Build new vehicle (add id + garageId)
  const vehicle = {
    ...vehicleData,
    id: vehicleId,
    garageId,
  };

  // Build analyses map
  const analyses = {};
  if (analysisData) {
    analyses[vehicleId] = JSON.parse(analysisData);
  }

  // Transform service history entries — add vehicleId
  let entries = [];
  if (serviceHistory) {
    entries = JSON.parse(serviceHistory).map((e) => ({
      ...e,
      vehicleId,
    }));
  }

  // Build chat histories map
  const chatHistories = {};
  if (chatHistory) {
    chatHistories[vehicleId] = JSON.parse(chatHistory);
  }

  // Write new keys
  localStorage.setItem('pm_garages', JSON.stringify([garage]));
  localStorage.setItem('pm_vehicles', JSON.stringify([vehicle]));
  localStorage.setItem('pm_analyses', JSON.stringify(analyses));
  localStorage.setItem('pm_service_history', JSON.stringify(entries));
  localStorage.setItem('pm_chat_histories', JSON.stringify(chatHistories));

  // Remove old keys
  localStorage.removeItem('pm_vehicle');
  localStorage.removeItem('pm_analysis');
  localStorage.removeItem('pm_chat_history');

  // pm_aa_analyses stays as-is (not vehicle-scoped)
}
